import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { LdsComponentsModule } from '@liberty-financial/ng-components';
import { LoadModule } from '../load/load.module';
import { PipesModule } from '../../pipes/pipes.module';

import { AuditListComponent } from './audit-list/audit-list.component';
import { AuditService } from './services/audit.service';
import { EventTypePipe } from './pipes/event-type.pipe';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LdsComponentsModule,
    LoadModule,
    PipesModule
  ],
  declarations: [
    AuditListComponent,
    EventTypePipe
  ],
  exports: [
    AuditListComponent
  ],
  providers: [
    AuditService
  ]
})
export class AuditModule {} 